import React from 'react';
import { Avatar } from 'antd';
import Text from 'antd/lib/typography/Text';
import classNames from 'classnames';

export interface AvatarStatusProps {
  suffix?: string;
  size?: number;
  shape?: 'circle' | 'square';
  gap?: number;
  text?: number;
  name?: string | React.ReactNode;
  subtitle?: React.ReactNode;
  src?: string;
  icon?: React.ReactNode;
  type?: string;
  className?: string;
}

const renderAvatar = (props: AvatarStatusProps) => {
  return (
    <Avatar
      {...props}
      className={`d-flex flex-shrink-0 align-items-center justify-content-center ant-avatar-${props.type}`}
    >
      {props.text}
    </Avatar>
  );
};

export const AvatarStatus = (props: AvatarStatusProps) => {
  const { name, suffix, subtitle } = props;
  return (
    <div
      className={classNames('avatar-status d-flex align-items-center flex-shrink-1', props.className)}
      style={{ minWidth: 0 }}
    >
      {renderAvatar(props)}
      {(name || suffix || subtitle) && (
        <div className="ml-3 d-flex flex-column flex-shrink-1" style={{ minWidth: 0 }}>
          <Text ellipsis>
            {typeof name === 'string' ? <span className="avatar-status-name">{name}</span> : name}
            <span>{suffix}</span>
          </Text>
          <Text className="text-content-secondary avatar-status-subtitle">{subtitle}</Text>
        </div>
      )}
    </div>
  );
};

export default AvatarStatus;
